
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'oxd-autocomplete-option',

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['select'],

  methods: {
    onClick() {
      if (this.disabled) return;
      this.$emit('select');
    },
  },
});
